import React from 'react';

// External Libraries
import { GIButton, Modal } from 'app-components';

// Components
import AlertMessage from '../../../../components/individualPortal/dashboard/AlertMsgs/AlertMessage';

// Constants
import { ALERT_TYPES } from '../../../../constants/individualPortal/dashboard/dashboardModelTypes';

// Contexts
import { ModalContextType } from '../../../../contexts/modalContext';

// Styles
import { StyledModalButtonFooter } from '../plansummary.styled';

// Modals
import { FormattedMessage } from 'react-intl';

interface IModalProps extends ModalContextType {}

const APTCFailureModal = ({ closeAllModals }: IModalProps) => {
    return (
        <Modal id="aptc_modal">
            <Modal.Header id="modal_header" titleId={'plansummary.atpcErrorModal.header'} onHide={closeAllModals} />
            <Modal.Body>
                <div>
                    <AlertMessage
                        content={
                            <p>
                                <FormattedMessage id="plansummary.atpcErrorModal.error" />
                            </p>
                        }
                        type={ALERT_TYPES.ERROR}
                        showIcon={false}
                    />
                </div>
            </Modal.Body>
            <Modal.Controls>
                <StyledModalButtonFooter>
                    <GIButton id="close_btn" labelId="button.close" variant="secondary" onClickHandler={closeAllModals} />
                </StyledModalButtonFooter>
            </Modal.Controls>
        </Modal>
    );
};

export default APTCFailureModal;
